export const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: '📊',
      path: '/dashboard'
    },
    {
      id: 'enquiries',
      label: 'Enquiries (RFQ)',
      icon: '📥',
      path: '/enquiries'
    },
    {
      id: 'local-quotations',
      label: 'Local Quotations',
      icon: '✅',
      path: '/local-quotations',
      roleRestrictions: ['local_admin', 'admin']
    },
    {
      id: 'sales-pipeline',
      label: 'Sales Pipeline (Offers)',
      icon: '🧩',
      path: '/sales-pipeline'
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: '🏢',
      path: '/customers'
    },
    {
      id: 'stock',
      label: 'Stock Matching',
      icon: '📦',
      path: '/stock'
    },
    {
      id: 'reports',
      label: 'Reports',
      icon: '📈',
      path: '/reports'
    },
    {
      id: 'outstanding',
      label: 'Payments',
      icon: '💰',
      path: '/outstanding'
    },
    {
      id: 'team',
      label: 'Team',
      icon: '👥',
      hasSubmenu: true,
      submenu: [
        { label: 'Members', path: '/users' },
        { label: 'Schedule', path: '/schedule' },
        { label: 'SCOT Calls', path: '/scot' }
      ]
    }
];

export const hasAccess = (menuItem, userRole) => {
  if (!menuItem.roleRestrictions || menuItem.roleRestrictions.length === 0) return true;
  return menuItem.roleRestrictions.includes(userRole);
};

export const getFilteredMenuItems = (userRole) => {
  return menuItems.filter(item => hasAccess(item, userRole));
};
